import React from 'react'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'
import * as yup from 'yup'
import { Field, Formik } from 'formik'

import TextField from '../TextField'
import Button from '../Button'
import Form, { Heading } from '../Form'

const CREATE_TEMPLATE = gql`
  mutation createTemplate(
  $key: String!
  $name: String!
  ) {
    createTemplate(
      key: $key
      name: $name
    ) {
      id
    }
  }
`

const validationSchema = yup.object().shape({
  key: yup.string().lowercase('Use lowercase characters only').strict().matches(/^[-a-z0-9]+$/, 'Contains invalid characters').required('Key is required'),
  name: yup.string().required('Name is required')
})

const INITIAL_VALUES = {
  key: '',
  name: ''
}

const onSubmit = (values, {setSubmitting}, createTemplate) => {
  createTemplate({variables: values})
  setSubmitting(false)
}

const Create = ({onCompleted, onError}) =>
  <Mutation
    mutation={CREATE_TEMPLATE}
    onCompleted={onCompleted}
    onError={onError}>
    {(createTemplate, {loading}) =>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => onSubmit(values, actions, createTemplate)}>
        {({isSubmitting}) =>
          <Form>
            <Heading>General</Heading>
            <Field component={TextField} name='key' label='Template Key (lowercase with no spaces or special characters except for "-")' required autoComplete='off' />
            <Field component={TextField} name='name' label='Publicly Visible Name?' required autoComplete='off' />
            <Button type='submit' fluid disabled={loading || isSubmitting}>Create New Template</Button>
          </Form>
        }
      </Formik>
    }
  </Mutation>

export default Create


// WEBPACK FOOTER //
// ./src/components/Templates/Create.js